// Public doctor profiles (v1). The legacy client called a route that never existed.
import api from './client';

const DoctorApi = {
  async getDoctor(doctorId) {
    const r = await api.get(`/doctors/${encodeURIComponent(doctorId)}`);
    return r.data;
  },
};

export default DoctorApi;
